import babyNameGeneratorIcon from "../../assets/baby-name-generator-icon.svg";

export default function BabyNameGeneratorLauncher() {
  return (
    <div className="relative">
      <a
        href="https://v0-baby-name-generator-weld.vercel.app/"
        target="_blank"
        rel="noopener noreferrer"
        className="relative flex flex-col items-center group"
        aria-label="우리아이 태명짓기"
      >
        <div
          className="
      mb-2
      rounded-full
      bg-white
      px-2 py-1
      text-sm
      font-extrabold
      text-main
      shadow
    "
        >
          우리아이 태명짓기
        </div>

        <div
          className="
        relative
        h-16 w-16
        sm:h-18 sm:w-18
        md:h-20 md:w-20
        rounded-full
        border-[4px]
        border-main
        bg-white
        shadow-xl
        flex items-center justify-center
        transition
        group-hover:scale-105
      "
        >
          <img
            src={babyNameGeneratorIcon}
            alt="우리아이 태명짓기"
            className="h-[100%] w-[100%] object-contain select-none"
            draggable={false}
          />

          <span className="absolute -top-1 -right-1 h-3 w-3 rounded-full bg-main animate-ping" />
          <span className="absolute -top-1 -right-1 h-3 w-3 rounded-full bg-main" />
        </div>
      </a>
    </div>
  );
}
